export default {
  styleOverrides: {
    root: {
      borderRadius: '10px'
    },
    outlined: {
      borderRadius: '32px',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '28px',
      boxShadow: '0 1px 1px 0 rgba(0,0,0,0.14)',
      padding: '7px 24px',
      label: {
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '36px'
      }
    },
    contained: {
      borderRadius: '32px',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '28px',
      boxShadow: '0 1px 1px 0 rgba(0,0,0,0.14)',
      padding: '8px 24px',
      label: {
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '36px'
      }
    },
    text: {
      borderRadius: '32px',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '28px',
      padding: '8px 24px',
      label: {
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '36px'
      }
    }
  }
};
